import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { Button } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';

const StoreFinderFilterWarning = ({ clearAllFilters , hasActiveFilters , applyActiveFilters ,  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const filteredStores = React.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    if (stores.length === 0) {
        return null;
    }
    if (!hasActiveFilters) {
        return null;
    }
    if (filteredStores.length !== 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        type: "warning",
        icon: "warning",
        message: /*#__PURE__*/ React.createElement(React.Fragment, null, getLabel('stores.page.search.filters.warning'), ' ', /*#__PURE__*/ React.createElement(Button, {
            className: "store-finder-stores-v2__clear-filters-action",
            variant: "ghost",
            onClick: clearAllFilters
        }, getLabel('stores.page.search.filters.clearButton')))
    });
};
var StoreFinderFilterWarning$1 = StoreFinderFilterWarning;

export { StoreFinderFilterWarning, StoreFinderFilterWarning$1 as default };
//# sourceMappingURL=StoreFinderFilterWarning.js.map
